import { Attachment } from '../attachment/attachment';
import { Ticket } from '../ticket/ticket';
import { Role } from '../authenticate/role';
import { Client } from '../client/client';

export class User {
    id: number;
    username: string;
    password: string;
    firstname: string;
    lastname: string;
    avatar: Attachment;
    email: string;
    tickets: Ticket[];
    role: Role;
  img: string;
  client: Client;
  privilege : string; 
}
